<template>
    <div class="load-mask-parent">
        <component-title
            :config="config">
        </component-title>
        <div :class="loadMask"></div>
        <div ref="my-map" style="height: 890px; z-index: 0;">
        </div>
    </div>
</template>
<script>

import Map from "leaflet";
import ComponentTitle from "./ComponentTitle";
import ValueChecker from "../services/ValueChecker";
import State from "@/Models/State.ts";

let markerIcon = require('../assets/img/marker.svg');

export default {
    components: {ComponentTitle},
    props: {
        config: {
            Type: Object,
            default: function () {
                return {
                    startPositionLatitude: null,
                    startPositionLongitude: null,
                    index: {},
                    emitEvents: {},
                    visible: true,
                }
            }
        },
        eventBus: {
            Type: Object,
        },
        routeParams: {
            Type: Object
        },
        queryParams: {
            Type: Object
        },
        moduleName: {
            Type: String,
            require: true,
        },
    },
    computed: {
    },
    data() {
        return {
            loadMask: '',
            map: null,
            mapLayer: null,
            startPositionLatitude: null,
            startPositionLongitude: null,
            state: new State(),
        };
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    inject: ['eventManager'],
    mounted() {
        this.init();
        this.setState(this.routeParams)
            .setState(this.queryParams);
        this.initMap();
        this.mountEvents();
        this.eventManager.emitEvents(this.config.emitEvents['mounted'] || [], []);
    },
    methods: {
        init() {
            this.componentIndex = this.config.index;
            this.startPositionLongitude = this.config.startPositionLongitude;
            this.startPositionLatitude = this.config.startPositionLatitude;
        },
        initMap() {
            let map = Map.map(this.$refs['my-map'])
                .setView(new L.LatLng(this.config.startPositionLatitude, this.config.startPositionLongitude), this.config.zoom);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);
            this.map = map;
        },
        async load(eventData, data) {
            this.addLoadMask();
            let response = await this.fetchData(data);
            this.markPoints(response.data, this.map);
            this.removeLoadMask();
        },
        async fetchData(params) {
            this.setState(params);
            const url = this.config['loadUrl'];

            return await this.$http.get(url, {params: params});
        },
        defaultBindEvents() {
            return [{
                name: 'load',
                componentIndex: this.componentIndex,
            }];
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        unmountEvents() {
            this.eventManager.unbindEvents(this.defaultBindEvents());
        },
        addLoadMask() {
            this.loadMask = 'lmask';
        },
        setState(data) {
            this.state.value = data;

            return this;
        },
        removeLoadMask() {
            this.loadMask = '';
        },
        markPoints(points, map) {
            let myIcons = L.icon({
                iconUrl: markerIcon,
                iconSize: [29, 40],
                iconAnchor: [9, 21],
                popupAnchor: [0, -14],
            });

            if (!ValueChecker.isUndefinedOrNull(this.mapLayer)) {
                map.removeLayer(this.mapLayer);
            }

            let markersLayer = new L.FeatureGroup();

            points.forEach(v => {
                let marker = L.marker([v.latitude, v.longitude], { icon: myIcons });
                marker.bindPopup(`<h5><b>${v.shop_name}</b></h5><p>${v.name}</p><p>${v.address}</p>`, {showOnMouseOver:true}).openPopup();
                markersLayer.addLayer(marker);
            });

            this.mapLayer = markersLayer;
            map.addLayer(markersLayer);
        },
    },
}

</script>

<style scoped>
    @import "./../../node_modules/leaflet/dist/leaflet.css";

    /* override for map set z-index */
    .lmask {
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: #c9d5c9;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        z-index: 401;
    }
</style>



// WEBPACK FOOTER //
// MapComponent.vue?7041cc81